import { appprox } from "@/common/variables";
import DOMPurify from "dompurify";

export function replaceVirguleFloat(value) {
  const a = value.replace(",", ".");
  return value && a !== "" ? a : 0;
}

export function montantLigne(ligne) {
  const a =
    ligne && ligne.linkRobCommandes
      ? Math.round(
          (ligne.montant_ttc -
            ligne.linkRobCommandes.reduce(
              (partialSum, a) => partialSum + a.montant_ttc,
              0
            )) *
            100
        ) / 100
      : null;
  return a;
}

export function commandeLigne(ligne, commandes) {
  const montant = montantLigne(ligne);
  const tvas = ligne.montant.split(",").map(function (item) {
    return parseFloat(item.split(":")[0]);
  });
  const items = commandes
    .filter(function (item) {
      const tmpMontant =
        item.isAbonnement && item.montant_abonnement !== 0
          ? item.montant_abonnement
          : item.montant - item.montant_utilise;
      return (
        item.old === false &&
        item.is_active &&
        item.montant > 0 &&
        item.montant - item.montant_utilise > 0 &&
        tvas.some(function (tva) {
          return (
            tmpMontant * (1 - appprox) * (1 + tva / 100) <= montant &&
            tmpMontant * (1 + appprox) * (1 + tva / 100) >= montant
          );
        })
      );
    })
    .filter(function (item) {
      return (
        ligne.linkRobCommandes.length === 0 ||
        ligne.linkRobCommandes.filter(function (link) {
          return link.commande.id === item.id;
        }).length === 0
      );
    });
  return items.map(function (item) {
    const tmpMontant =
      item.isAbonnement && item.montant_abonnement !== 0
        ? item.montant_abonnement
        : Math.round((item.montant - item.montant_utilise) * 100) / 100;
    return {
      id: "new",
      commande: item,
      tva: tvas.filter(function (tva) {
        const com_ttc = ((tva + 100) / 100) * tmpMontant;
        return (
          montant * (1 - appprox) <= com_ttc &&
          montant * (1 + appprox) >= com_ttc
        );
      })[0],
      montant_tva: Math.round(Math.abs(tmpMontant - montant) * 100) / 100,
      montant_ht: tmpMontant,
      montant_ttc:
        Math.round(Math.abs(tmpMontant - montant) * 100) / 100 + tmpMontant,
      compteComptable: item.compteComptable,
      montant_abonnement: item.montant_abonnement,
      montant_isAbonnement:
        item.montant_abonnement !== null && item.montant_abonnement > 0,
    };
  });
}

export function toTop(elem) {
  document.getElementById(elem).scrollTop = 0;
}

export function sanitizedTextContent(text) {
  return DOMPurify.sanitize(text);
}
